import { ICardElementWithChildren } from "backend/model/model";
import clsx from "clsx";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import { DonutKpiInitiative } from "../charts/DonutKpiInitiative";
import { IChartSelectEvent } from "../charts/types";
import OverallHeader from "../texts/OverallHeader";
import { OverallCard } from "./OverallCard";

const useElementOverviewDonutCardStyles = makeThemedStyles(
  "ElementOverviewDonutCard",
  (theme) => ({
    container: {
      marginTop: "-30px",
      display: "flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
    },
  })
);

export const ElementOverviewDonutCard = React.memo(
  (
    props: React.PropsWithChildren<{
      data: ICardElementWithChildren[];
      title: string;
      typenames: string[];
      periodName: string;
      disableAnimation?: boolean;
      onSelect?: (value: IChartSelectEvent) => void;
    }>
  ) => {
    const styles = useElementOverviewDonutCardStyles();
    const { data } = props;
    return (
      <OverallCard>
        <OverallHeader title={props.title} periodName={props.periodName} />
        <div className={clsx(styles.container, "chart")}>
          <DonutKpiInitiative
            element={data}
            perfColorKey="rangecolor"
            perfNameKey="rangename"
            typenames={props.typenames}
            onSelect={props.onSelect}
            disableAnimation={props.disableAnimation}
          />
        </div>
      </OverallCard>
    );
  }
);

export default ElementOverviewDonutCard;
